import { render, staticRenderFns } from "./PrimaryContactToggle.vue?vue&type=template&id=748eba8f&scoped=true&"
import script from "./PrimaryContactToggle.vue?vue&type=script&lang=js&"
export * from "./PrimaryContactToggle.vue?vue&type=script&lang=js&"
import style0 from "./PrimaryContactToggle.vue?vue&type=style&index=0&id=748eba8f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "748eba8f",
  null
  
)

export default component.exports